<template>
  <ul class="nav nav-pills px-2">
    <li class="nav-item">
      <router-link class="nav-link" to="/">Главная</router-link>
    </li>
    <template v-if="user.role.name == 'Администратор'">
      <li class="nav-item">
        <router-link class="nav-link" to="/boards-list">Доски</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/users-list"
          >Пользователи</router-link
        >
      </li>
      <li class="nav-item">
        <router-link class="nav-link" to="/permission-list"
          >Доступы</router-link
        >
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  props: ["user"],
  data() {
    return {};
  },
};
</script>

<style >
</style>